import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const nbaStandingsHeaders = {
  "X-Master-Key":
    "$2b$10$fRKe0VHNekIpz2c58Y6y8.58x5oKpXzMlRY0du043sOzBXgFmRtkK",
};

const baseUrl = "https://api.jsonbin.io/v3";

const createRequest = (url) => ({ url, headers: nbaStandingsHeaders });

export const nbaStandings = createApi({
  reducerPath: "nbaStandings",
  baseQuery: fetchBaseQuery({ baseUrl }),
  tagTypes: ["Standings"],
  endpoints: (builder) => ({
    getStandings: builder.query({
      query: () => createRequest(`/b/62daab8a2c868775a533319a`),
      providesTags: ["Standings"],
    }),
  }),
});

export const { useGetStandingsQuery } = nbaStandings;
